import React from 'react';
import { Button } from '@codex/basics';
import styled from 'styled-components';
import productIdStorage from '../productIdStorage';
import { getString } from '../../../../../utils/UILocale';
import * as UISettings from '../../../../../utils/UISettings';

const StyledButton = styled(Button)`
  margin-bottom: 20px;
`;

function redirectToUserEligibilityChecker() {
  const eligibilityCheckUrl = UISettings.get('component.eligibilityCheck.url');
  productIdStorage.save();
  window.location.href = `${eligibilityCheckUrl}`;
}
const buttonCaption = getString('component.eligibilityCheck.check_eligibility_button') || '';
const EligibilityButton = () => (
  <StyledButton
    full
    onClick={redirectToUserEligibilityChecker}
    data-interaction={'Check Eligibility'}
  >
    {buttonCaption}
  </StyledButton>
);

export default EligibilityButton;
